import React from "react";
import PropTypes from "prop-types";
import Tippy from '@tippyjs/react';
import AsyncSelect from "react-select/async";
import FanFilterSelect from "./FanFilterSelect";

import { formInputContainerStyle } from "./FanFilterGroupForm";

const contactTypeOption = (contactType) => ({
  value: contactType.id,
  label: contactType.archived ? `${contactType.name} (archived)` : contactType.name,
});

const ContactTypeDataForm = (props) => {
  const {
    fanFilter,
    updateFanFilter,
  } = props;

  const conditions = fanFilter.filter_param_options.condition || [];
  const contactTypes = fanFilter.filter_param_options.contact_types || [];

  const condition = fanFilter.filter_params.condition || "";
  const contactTypeIds = fanFilter.filter_params.contact_type_ids || [];

  const loadContactTypeOptions = (inputValue, callback) => {
    const normalizedInput = (inputValue || "").toLowerCase();
    callback(
      contactTypes
        .filter((contactType) => !normalizedInput || (contactType.name || "").toLowerCase().includes(normalizedInput))
        .map(contactTypeOption)
    );
  };

  const selectedOptions = contactTypes
    .filter((contactType) => contactTypeIds.some((id) => String(id) === String(contactType.id)))
    .map(contactTypeOption);

  return (
    <>
      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Select a condition"
          placeholder="Select a condition"
          options={conditions.map((cond) => ({ value: cond, label: cond }))}
          value={condition || null}
          onChange={(value) => {
            updateFanFilter({
              filter_params: {
                ...fanFilter.filter_params,
                condition: value,
              },
            });
          }}
        />
      </div>

      <div style={formInputContainerStyle}>
        <AsyncSelect
          classNamePrefix="react-select"
          menuPortalTarget={document.body}
          isMulti
          aria-label="Select contact types"
          placeholder="Select contact types"
          defaultOptions
          value={selectedOptions}
          loadOptions={loadContactTypeOptions}
          noOptionsMessage={() => "No contact types"}
          onChange={(options) => {
            updateFanFilter({
              filter_params: {
                ...fanFilter.filter_params,
                contact_type_ids: (options || []).map((option) => parseInt(option.value, 10)),
              },
            });
          }}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              minWidth: "260px",
              borderRadius: "8px",
              border: selectedOptions.length ? "1px solid var(--sl-border-primary, #ccc)" : "1px solid var(--sl-border-error, #FF595E)",
            }),
            menuPortal: (baseStyles) => ({ ...baseStyles, zIndex: 9999 }),
            menu: (baseStyles) => ({
              ...baseStyles,
              width: "max-content",
              maxWidth: "500px",
            }),
          }}
        />
      </div>

      {fanFilter.filter_validation_errors.length ? (
        <Tippy content={fanFilter.filter_validation_errors.join(" ")}>
          <i className="far fa-circle-exclamation" style={{color: "var(--sl-text-error, #FF595E)" }}/>
        </Tippy>
      ) : null}
    </>
  );
};

ContactTypeDataForm.propTypes = {
  fanFilter: PropTypes.shape({
    filter_params: PropTypes.object.isRequired,
    filter_param_options: PropTypes.object.isRequired,
    filter_validation_errors: PropTypes.array.isRequired,
  }).isRequired,
  updateFanFilter: PropTypes.func.isRequired,
};

export default ContactTypeDataForm;
